import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const EditContainer = styled(Box)({
  padding: '24px', // p={3}
  backgroundColor: '#F3F6FE',
  borderRadius: '16px', // 4 * 4px (default theme spacing unit)
  height: '300px',
  overflow: 'scroll',
  minHeight: '100px',

  scrollbarWidth: 'thin', // Firefox
  scrollbarColor: 'black transparent', // Firefox

  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'black',
    borderRadius: '4px',
  },
});

export default EditContainer;